var render, staticRenderFns
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Logo.vue?vue&type=custom&index=0&blockType=svg&width=288&height=288&xmlns=http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg&version=1.1&xmlns%3Axlink=http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink&xmlns%3Asvgjs=http%3A%2F%2Fsvgjs.com%2Fsvgjs"
if (typeof block0 === 'function') block0(component)

export default component.exports